import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Box } from '../Box/Box.js';
import { FocusTrap } from '../FocusTrap/FocusTrap.js';
import { Overlay } from '../Modal/Overlay.js';
import { useSideSheet } from './useSideSheet.js';
import { defaultProps } from './SideSheet.mappers.js';

var _excluded = ["children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var ContainerBox = Box;
var SideSheet = function SideSheet(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  var propsWithDefault = _objectSpread(_objectSpread({}, defaultProps), rest);
  var _useSideSheet = useSideSheet(propsWithDefault),
    header = _useSideSheet.header,
    overlayProps = _useSideSheet.overlayProps,
    focusTrapProps = _useSideSheet.focusTrapProps,
    containerBoxProps = _useSideSheet.containerBoxProps,
    shouldRenderOverlay = _useSideSheet.shouldRenderOverlay,
    shouldRenderBottomSheet = _useSideSheet.shouldRenderBottomSheet;
  if (!shouldRenderOverlay && !shouldRenderBottomSheet) return null;
  return /*#__PURE__*/React.createElement(Overlay, overlayProps, /*#__PURE__*/React.createElement(FocusTrap, focusTrapProps, /*#__PURE__*/React.createElement(ContainerBox, containerBoxProps, header, children)));
};
var SideSheetMemoized = /*#__PURE__*/React.memo(SideSheet);
SideSheetMemoized.displayName = 'SideSheet';

export { SideSheet as BaseSideSheet, SideSheetMemoized as SideSheet };
//# sourceMappingURL=SideSheet.js.map
